import CreateFolderButton from './CreateFolderButton';
import CreateBookmarkButton from './CreateBookmarkButton';

type AdminBookmarksActionsProps = {
  selectedFolderKey?: string;
}

const AdminBookmarksActions = ({ selectedFolderKey } : AdminBookmarksActionsProps) : JSX.Element => {
  return (
    <div className="flex flex-row gap-2w flex-wrap justify-end">
      {!selectedFolderKey && <CreateFolderButton />}
      <CreateBookmarkButton selectedFolderKey={selectedFolderKey} />
    </div>);
}

export default AdminBookmarksActions;